import { ReactNode } from 'react';

import { styled } from '@mui/material';

import { ButtonsContainer, Card, Divider } from '@app-velocity/ui';

import { TotalReportsCount } from '@app-velocity/libs/report';

import { FigmaReportsList } from './components/FigmaReportsList';
import { FigmaFilters } from './components/FigmaFilters';
import { FigmaPluginDownloadButton } from './components/FigmaPluginDownloadButton';

const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: theme.spacing(3),
}));

type FigmaReportsProps = {
  tabs?: ReactNode;
};

export const FigmaReports = ({ tabs }: FigmaReportsProps) => {
  return (
    <>
      <StyledCard>
        <FigmaFilters />
      </StyledCard>
      <TotalReportsCount />
      {tabs}
      <FigmaReportsList />
      <Divider />
      <ButtonsContainer align="center">
        <FigmaPluginDownloadButton />
      </ButtonsContainer>
    </>
  );
};
